import type { DtActionsAtom } from '@/components/pages/backoffice/_klb-penyuluh/_kecamatan/state/atoms'
import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { PenghargaanDataType } from './types'
import type { MutationPenghargaanValues } from './validations'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['penghargaan', key] as const

const getAll = (
  params?: DtActionsAtom
): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<PenghargaanDataType>>
> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<PenghargaanDataType>>
      >(`kelembagaan/bpp/${params?.id_bpp}/penghargaan`, {
        params: {
          page: params?.page,
          per_page: params?.perPage || undefined
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getById = (
  id: string,
  id_bpp?: string
): ServiceQueryOptionType<ServiceGetByIdResponse<PenghargaanDataType>> => ({
  queryKey: QUERY_KEY(id),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetByIdResponse<PenghargaanDataType>
      >(`kelembagaan/bpp/${id_bpp ?? ''}/penghargaan/${id}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const create = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<PenghargaanDataType>,
  MutationPenghargaanValues
> => ({
  mutationKey: QUERY_KEY(undefined),
  mutationFn: async (data: MutationPenghargaanValues) => {
    try {
      const response = await api.post(
        `kelembagaan/bpp/${data.id_bpp ?? ''}/penghargaan`,
        {
          ...data
        }
      )

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const update = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<PenghargaanDataType>,
  MutationPenghargaanValues
> => ({
  mutationKey: QUERY_KEY(undefined),
  mutationFn: async (data: MutationPenghargaanValues) => {
    try {
      const response = await api.put<
        ServiceGetByIdResponse<PenghargaanDataType>
      >(
        `kelembagaan/bpp/${data?.id_bpp ?? ''}/penghargaan/${data.id_penghargan}`,
        {
          ...data
        }
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const deleteData = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<PenghargaanDataType>,
  { id: string; id_bpp: string }
> => ({
  mutationFn: async (data: { id: string; id_bpp: string }) => {
    try {
      const response = await api.delete<
        ServiceGetByIdResponse<PenghargaanDataType>
      >(`kelembagaan/bpp/${data?.id_bpp ?? ''}/penghargaan/${data.id}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const penghargaan = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll,
  getById,
  create,
  update,
  deleteData
}
